module.exports = __webpack_public_path__ + "img/alfa_token.alpha.23f1d62.png";